<template>
  <div
    style="height: 100%;"
    class="d-flex flex-column"
  >
    <div
      class="d-flex align-center flex-wrap"
    >
      <span style="white-space: nowrap;">
        CSS 混合模式
      </span>
      <v-btn
        v-for="item in modelist"
        :key="item"
        small
        class="ma-2"
        @click="setMode(item)"
      >
        {{ item }}
      </v-btn>
    </div>
    <div
      class="d-flex align-center flex-wrap"
    >
      <span style="white-space: nowrap;">文字颜色</span>
      <v-color-picker
        v-model="color"
        class="ma-2"
        hide-canvas
        style="border: 1px solid;"
        @input="setColor($event)"
      />
      <v-btn
        small
        class="ma-2"
        @click="setColor('#000000ff')"
      >
        黑色
      </v-btn>
      <v-btn
        small
        class="ma-2"
        @click="setColor('#ffffffff')"
      >
        白色
      </v-btn>
      <span>
        {{ color }}
      </span>
    </div>
    <div
      class="bg"
      @mousemove="handleDragBox"
      @mouseup="isSelectBox = false"
    >
      <span
        ref="text"
        class="text"
        @mousedown="isSelectBox = true"
      >颜色混合模式:{{ mode }}</span>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      isSelectBox: false,
      mode: 'overlay',
      color: '#ff0000dd',
      modelist: [ 'normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity', 'plus-darker', 'plus-lighter' ]
    }
  },

  mounted () {
    this.setMode(this.mode)
    this.setColor(this.color)
  },

  methods: {
    setMode (mode) {
      this.mode = mode
      const text = document.querySelector('.text')
      text.style.setProperty('--mix-blend-mode', mode)
    },
    setColor (color) {
      this.color = color
      const text = document.querySelector('.text')
      if (!text) {
        return
      }
      text.style.setProperty('--fontcolor', color)
    },
    handleDragBox (e) {
      if(this.isSelectBox) {
        // console.log(e.movementX, e.movementY);
        const boxElement = this.$refs.text;
        const boxx = this.$refs.text.offsetLeft;
        const boxy = this.$refs.text.offsetTop;
        boxElement.style.left = `${boxx + e.movementX}px`;
        boxElement.style.top = `${boxy + e.movementY}px`;
      }
    }
  }

}

</script>

<style scoped>
.bg {
  background: conic-gradient(from 0deg at center, #ff0000, #00ff00, #0000ff, #ff0000);
  height: 100%;
  position: relative;
}

.text {
  /* 混合模式 */
  font-size: 60px;
  white-space: nowrap;
  mix-blend-mode: var(--mix-blend-mode, normal);
  color: var(--fontcolor, white);
  /* 抓手 */
  cursor: grab;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
/* 按下抓住 */
.text:active {
  cursor: grabbing;
}

</style>
